import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { SupportContentType, IBeetleId } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

export type DeletePayloadType = {
  id: IBeetleId;
  env: Environment;
};

export const deleteIssueMutationKey: MutationKey = ['mutation', 'delete'];

export const useDelete = (
  method: SupportContentType,
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, DeletePayloadType>
) => {
  const service = methods(method);
  return useEitherMutation(({ id, env }) => service.deleteEntity(id, env), {
    mutationKey: deleteIssueMutationKey,
    ...options,
  });
};
